import { render, staticRenderFns } from "./FormHomeDelivery.pug?vue&type=template&id=51efbc17&lang=pug&"
import script from "./FormHomeDelivery.vue?vue&type=script&lang=js&"
export * from "./FormHomeDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports